const tenantId = process.env.REACT_APP_AAD_TENANT_ID || "6d51aeef-5f24-4438-962f-fa4688371f2e" || "common";

export const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_AAD_CLIENT_ID || "0dcc3104-b143-43a4-98cb-33a93af418b9",
    authority: `https://login.microsoftonline.com/${tenantId}`,
    redirectUri: process.env.REACT_APP_REDIRECT_URI || "https://localhost:3000"
  },
  cache: {
    cacheLocation: "localStorage", // Persist across reloads/tabs
    storeAuthStateInCookie: true
  }
};

export const loginRequest = {
  scopes: ["User.Read"]
};